import { DeepPartial, createUseThemeHook } from 'legos/theme';

declare module 'legos/theme' {
  interface BulkLegoTheme {
    talkDeskChatButton: DeepPartial<TalkdeskChatButtonTheme>;
  }
}

export interface TalkdeskChatButtonTheme {
  leftIcon: string;
  rightIcon: string;
}

export const [
  TalkdeskChatButtonThemeProvider,
  useTalkdeskChatButtonTheme
] = createUseThemeHook(
  'talkDeskChatButton',
  (global): TalkdeskChatButtonTheme => ({
    leftIcon: global.special.color500,
    rightIcon: global.special.color200
  })
);
